import { getApi } from './common/apis';

export default class AccountService {
    async getAccountData(accountId) {
        const accountData = await getApi(`v1/get-account?accountId=${accountId}`);
        return accountData;
    }
}
